import React from "react";
import { Card, Divider } from "antd";
import { 
  Calendar, 
  Clock 
} from "lucide-react";
import { formatDateRange } from "utils/index";
import ApprovalButtons from "components/button/approvalbuttons";
import { MODULE_LEAVE_REQUESTS } from "variables/constants";
import LeaveApprovalForm from "./LeaveApprovalForm";

const LeaveRequestCard = (props) => { 
  const leave = { ...props };

  return (
    <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-xl border border-orange-200 hover:shadow-md transition-shadow dark:bg-black/5">
      <div className="flex justify-between items-start relative gap-4">
        <span className={`absolute right-5 status-indicator ${leave?.lve_type_name?.toLowerCase().replace(/\s+/g, "-")}`}>
          {leave?.lve_type_name}
        </span>

        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 flex items-center justify-center rounded-full bg-green-100 text-green-700 font-semibold">
            {leave?.lve_employee_initials}
          </div>
          <div>
            <div className="flex flex-row gap-2">
              <h3 className="font-semibold text-slate-900 dark:text-white">{leave?.lve_employee_name}</h3>
              <span className="status-indicator normal text-[10px] px-2 dark:text-white">{leave?.lve_employee?.emp_code}</span>
            </div>
            <div className="flex items-center text-slate-700 text-sm dark:text-slate-100">{leave?.lve_employee?.emp_title}</div>
          </div>
        </div>
      </div>

      {leave?.lve_status_id === 70 ?
        <>
          <Divider style={{ margin: "1rem 0", borderColor: "#e5e7eb" }} />

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-2">
            <div>
              <p className="text-xs text-slate-700 mb-1 dark:text-slate-100">Start Date</p>
              <div className="flex items-center gap-1">
                <Calendar className="w-4 h-4 text-emerald-600 dark:text-emerald-300" />
                <span className="text-[13px] font-medium tracking-normal dark:text-white">{formatDateRange(leave?.lve_date_from)}</span>
              </div>
            </div>
            <div>
              <p className="text-xs text-slate-700 mb-1 dark:text-slate-100">End Date</p>
              <div className="flex items-center gap-1">
                <Calendar className="w-4 h-4 text-emerald-600 dark:text-emerald-300" />
                <span className="text-[13px] font-medium tracking-normal dark:text-white">{formatDateRange(leave?.lve_date_to)}</span>
              </div>
            </div>
            <div>
              <p className="text-xs text-slate-700 mb-1 dark:text-slate-100">Duration</p>
              <div className="flex items-center gap-1">
                <Clock className="w-4 h-4 text-purple-600 dark:text-purple-400" />
                <span className="text-[13px] font-medium tracking-normal dark:text-white">{leave?.lve_duration} day{leave?.lve_duration > 1 ? "s" : ""}</span>
              </div>
            </div>
            <div>
              <p className="text-xs text-slate-700 mb-1 dark:text-slate-100">Submitted</p>
              <span className="text-[13px] font-medium tracking-normal dark:text-white">{formatDateRange(leave?.created_at, null, false)}</span>
            </div>
          </div>

          <div>
            <p className="text-xs text-slate-700 mb-1 dark:text-slate-100">Reason</p>
            <p className="text-[13px] font-medium dark:text-white">{leave?.lve_reason}</p>
          </div>

          <Divider style={{ margin: "1rem 0", borderColor: "#e5e7eb" }} />

          <div className="pb-6">
            <div className="absolute right-1 gap-3 pr-6">
              <ApprovalButtons
                record={leave}
                recordIdKey="lve_id"
                employeeNameKey="lve_employee_name"
                moduleId={MODULE_LEAVE_REQUESTS}
                FormComponent={LeaveApprovalForm}
                modalPrefix="edit_leave_request"
              />
            </div>
          </div>
        </>
        :
        <div className="mt-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-2">
            <div>
              <p className="text-xs text-slate-700 mb-1 dark:text-slate-100">Duration</p>
              <span className="text-[13px] font-medium tracking-normal dark:text-white">{leave?.lve_duration} day{leave?.lve_duration > 1 ? "s" : ""}</span>
            </div>
            <div>
              <p className="text-xs text-slate-700 mb-1 dark:text-slate-100">Leave Period</p>
              <span className="text-[13px] font-medium tracking-normal dark:text-white">{formatDateRange(leave?.lve_date_from, leave?.lve_date_to, false, false)}</span>
            </div>
            <div>
              <p className="text-xs text-slate-700 mb-1 dark:text-slate-100">{leave?.lve_status_id === 71 ? "Approved" : "Rejected"} By</p>
              <span className="text-[13px] font-medium tracking-normal dark:text-white">{leave?.lve_approved_by_name}</span>
            </div>
            <div>
              <p className="text-xs text-slate-700 mb-1 dark:text-slate-100">{leave?.lve_status_id === 71 ? "Approved" : "Rejected"} On</p>
              <span className="text-[13px] font-medium tracking-normal dark:text-white">{formatDateRange(leave?.lve_approved_date, null, false)}</span>
            </div>
          </div>
          <div>
            {leave?.lve_status_id === 72 && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-3 mt-4">
                <p className="text-[12px] text-red-700 font-medium mb-1 dark:text-red-400">Reason</p>
                <p className="text-[13px] text-red-100">{leave?.lve_note}</p>
              </div>
            )}
          </div>
        </div>
      }

    </Card>
  );
};

export default LeaveRequestCard;
